const dateFilter = (time, type) => {
	if (!time) {
		return ' ';
	} else if (!type) {
		const date = new Date(time * 1000);
		const dateNumFun = num => (num < 10 ? `0${num}` : num);
		const [Y, M, D] = [date.getFullYear(), dateNumFun(date.getMonth() + 1), dateNumFun(date.getDate())];
		return `${Y}.${M}.${D} `;
	} else if (type == 'second') {
		const date = new Date(time * 1000);
		const dateNumFun = num => (num < 10 ? `0${num}` : num);
		const [Y, M, D, H, F, S] = [
			date.getFullYear(),
			dateNumFun(date.getMonth() + 1),
			dateNumFun(date.getDate()),
			dateNumFun(date.getHours()),
			dateNumFun(date.getMinutes()),
			dateNumFun(date.getSeconds()),
		];
		return `${Y}-${M}-${D}  ${H}:${F}:${S}`;
	}
};
const sourceFilter = value => {
	switch (value) {
		case '1':
			return 'PC';
		case '2':
			return 'H5';
		case '3':
			return 'Android';
		case '4':
			return 'Ios';
		default: return '--'
	}
};
const exclusiveDomain = value => {
	// 域名申请
	if (value == 0) {
		return '不可申请';
	} else {
		return '可申请';
	}
};
const transNum = (str, num) => {
	return (Math.round(str*100)/100).toFixed(num); 
}
const transNum2Cn = (str, num) => {
	if (str === 'unlimited') return '无限';
	var n = Number(str);
	if (n === 'NaN' || n == 0) {
		return '0元';
	}
	if (n == 1) {
		return '1元';
	} else if (n < 10000) {
		if (typeof num === 'number' && !isNaN(num)) {
			if (num == 2) {
				return n.toFixed(num);
			} else {
				return n.toFixed(num) + '元';
			}
		} else {
			return n.toFixed(4) + '元';
		}
	}
	var w = Math.trunc(n / 10000);

	var n = n.toString();
	var nq1 = Math.trunc(n.substr(1));
	var nq2 = Math.trunc(n.substr(2));
	var nq3 = Math.trunc(n.substr(3));
	var nq4 = Math.trunc(n.substr(4));
	var nq5 = Math.trunc(n.substr(5));

	if (w < 1) {
		return n + '元';
	} else if (w < 10) {
		return w + '万' + (nq1 > 0 ? nq1 : '') + '元';
	} else if (w < 100) {
		return w + '万' + (nq2 > 0 ? nq2 : '') + '元';
	} else if (w < 1000) {
		return w + '万' + (nq3 > 0 ? nq3 : '') + '元';
	} else if (w < 10000) {
		return w + '万' + (nq4 > 0 ? nq4 : '') + '元';
	} else {
		var y = w / 10000;
		if (y >= 1) {
			return y + '亿' + (n.substr(n.length - 4) == '0000' ? '' : n.substr(n.length - 4)) + '元';
		}
	}
};

//计算当月多少天
const monthlyAccumulation = str => {
	let value = parseInt(str);
	var curDate = new Date();
	/* 获取当前月份 */
	let curMonth = curDate.getMonth();
	/*  生成实际的月份: 由于curMonth会比实际月份小1, 故需加1 */
	curDate.setMonth(curMonth + 1);
	/* 将日期设置为0, 这里为什么要这样设置, 我不知道原因, 这是从太阳城H5复制过来的 */
	curDate.setDate(0);
	/* 返回当月的天数 */
	let days = curDate.getDate();
	return value * days;
};

//计算当年多少天
const yearlyAccumulation = str => {
	let value = parseInt(str);
	let year = new Date().getFullYear();
	let dayNum = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
	if (new Date(year, 1, 29).getDate() == 29) {
		dayNum[1] = 29;
	}
	let days = eval(dayNum.join('+'));
	return value * days;
};

//域名申请状态过滤
const domainFillter = value => {
	if (value == 0) {
		return '审核中';
	} else if (value == '1') {
		return '已通过';
	} else {
		return '已拒绝';
	}
};
//充值记录状态
const voucherStatusToZh = value => {
	switch (value) {
		case '0':
			return '待处理';
			break;
		case '1':
			return '成功';
			break;
		case '3':
			return '失败';
			break;
		case '2':
			return '掉单';
			break;
	}
};
//提现记录状态
const withdrawStatusToZh = value => {
	if (value == 0) {
		return '已提交';
	} else if (value == 1 || value == 2 || value == 3 || value == 4 || value == 5 || value == 6 || value == 9) {
		return '审核中';
	} else if (value == 8 || value == 11) {
		return '失败';
	} else if (value == 10) {
		return '成功';
	} else if (value == 12) {
		return '已拒绝';
	}
};

//转账记录状态
const transferStatusToZh = value => {
	if (value == 6) {
		return '成功';
	} else if (value == 1 || value == 5) {
		return '待转账';
	} else {
		return '失败';
	}
};

//过滤会员等级以及电子工资卡等级
const fillterLevel = (value, name) => {
	if (
		value == 'target_week_salari' ||
		value == 'target_bonus' ||
		value == 'anniversary_gift' ||
		value == 'birthday_gift' ||
		value == 'target_daily_signin'
	) {
		return '元';
	}
	if (value == 'target_vip_rebate_scale' || value == 'target_transfer_reward_scale' || value == 'integral_discount' || value=="target_payment_reward_scale") {
		return '%';
	}

	if (value == 'target_withdrawtimes') {
		return '';
	}
	if (value == 'ishave_exclusive_name') {
		return name == '1' ? '可申请' : '不可申请';
	}
};
const phoneNumFilter = phone => {
	// 1字符串转化成数组
	let phoneArr = [...phone];
	// 2.将数组中的4-7位变成*
	let str = '';
	if (phoneArr.length > 0) {
		phoneArr.map((res, index) => {
			if (index > 2 && index < 9) {
				str += '*';
				// return '*';
			} else {
				str += res;
				// return res;
			}
		});
	}
	return str;
};
const formatTime =(unixTimestamp, type) =>{
    let dt = new Date(unixTimestamp * 1000);
    if (!Number(unixTimestamp) || Number(unixTimestamp) <= 0 || Number(unixTimestamp) == 1) {
        return '—';
    }
    let year = dt.getFullYear();
    let month = dt.getMonth() + 1;
    let day = dt.getDate();
    let hours = dt.getHours();
    let minutes = dt.getMinutes();
    let seconds = dt.getSeconds();
    if (hours < 10) hours = '0' + hours;

    if (minutes < 10) minutes = '0' + minutes;

    if (seconds < 10) seconds = '0' + seconds;
    switch (type) {
        case 1:
            return hours + ':' + minutes + ':' + seconds; //小时:分钟:秒  格式
        case 2:
            return year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds; //年-月-日 小时:分钟:秒 格式
        case 3:
            return year + '-' + month + '-' + day; //年-月-日 格式
        case 4:
            return hours + ':' + minutes + ':' + seconds;
        case 5:
            return hours + ':' + minutes;
        case 6:
            return year + '-' + month + '-' + day + ' 00:00:00';
        case 7:
            return year + '-' + month + '-' + day + ' 23:59:59';
        default:
            return year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds; //年-月-日 小时:分钟:秒 格式
    }
}

export default {
	dateFilter,
	exclusiveDomain,
	transNum2Cn,
	yearlyAccumulation,
	monthlyAccumulation,
	domainFillter,
	voucherStatusToZh,
	withdrawStatusToZh,
	transferStatusToZh,
	fillterLevel,
	phoneNumFilter,
	transNum,
	sourceFilter,
	formatTime,
};
